module.exports = __webpack_public_path__ + "media/img/event/logo/ucam-76d7b50833ecebe55bdcfc2dfcee9766.jpg";